var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52667 5.18667V11.6733C1.52667 12.94 2.42667 13.46 3.52 12.8333L5.08667 11.94C5.42667 11.7467 5.99333 11.7267 6.34667 11.9067L9.84667 13.66C10.2 13.8333 10.7667 13.82 11.1067 13.6267L13.9933 11.9733C14.36 11.76 14.6667 11.24 14.6667 10.8133V4.32667C14.6667 3.06 13.7667 2.54 12.6733 3.16667L11.1067 4.06C10.7667 4.25334 10.2 4.27334 9.84667 4.09334L6.34667 2.34667C5.99333 2.17334 5.42667 2.18667 5.08667 2.38L2.2 4.03334C1.82667 4.24667 1.52667 4.76667 1.52667 5.18667Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70667 2.66666V11.3333",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4867 4.41333V13.3333",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.218e24c67301b0dd07c80cad7d915b57.svg";
export { ForwardRef as ReactComponent };